import React, { useEffect, useRef } from 'react';
import { Container, Typography, Box, Card, CardMedia } from '@mui/material';
import { useNavigate } from 'react-router-dom'; // 引入 useNavigate

// 所有图片路径（WebP 格式）
const allImages = [
  '/images/Melamine/Image_20241015222131.webp',
  '/images/Melamine/Image_20241015222249.webp',
  '/images/Melamine/Image_20241015223541.webp',
  '/images/PET/Image_20241015231116.webp',
  '/images/PET/Image_20241015231120.webp',
  '/images/Thermofoil/Image_20241015231009.webp',
  '/images/Thermofoil/Image_20241015231014.webp',
];

const BestSellingProduct = () => {
  const scrollContainerRef = useRef(null);
  const navigate = useNavigate(); // 使用 useNavigate

  // 自动滚动逻辑
  useEffect(() => {
    const interval = setInterval(() => {
      if (scrollContainerRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
        if (scrollLeft + clientWidth >= scrollWidth) {
          scrollContainerRef.current.scrollLeft = 0; // 回到起点
        } else {
          scrollContainerRef.current.scrollLeft += 1; // 每次移动一像素
        }
      }
    }, 30); // 每 30 毫秒滚动一次

    return () => clearInterval(interval); // 清理定时器
  }, []);

  const handleImageClick = () => {
    navigate('/gallery'); // 跳转到 Gallery 页面
  };

  return (
    <Box sx={{ backgroundColor: '#f0f0f0', padding: '50px 0' }}>
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          sx={{ fontWeight: 'bold', textAlign: 'center', marginBottom: '20px', color: '#000' }}
        >
          Best Selling Products
        </Typography>

        {/* 滚动容器 */}
        <Box
          ref={scrollContainerRef}
          sx={{
            display: 'flex',
            overflowX: 'hidden', // 禁用横向滚动条
            whiteSpace: 'nowrap',
            gap: '10px',
            padding: '10px 0',
            scrollBehavior: 'smooth',
            touchAction: 'none', // 禁用触摸滚动
            pointerEvents: 'auto', // 允许点击事件
            '&::-webkit-scrollbar': { display: 'none' }, // 隐藏滚动条
          }}
        >
          {allImages.map((image, index) => (
            <Card
              key={index}
              onClick={handleImageClick} // 添加点击事件
              sx={{
                display: 'inline-block',
                minWidth: 300,
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                cursor: 'pointer',
                '&:hover': {
                  transform: 'scale(1.05)',
                  transition: 'transform 0.3s ease-in-out',
                },
              }}
            >
              <CardMedia
                component="img"
                image={image}
                alt={`Product Image ${index + 1}`}
                sx={{
                  width: '100%',
                  height: 200,
                  objectFit: 'cover',
                }}
              />
            </Card>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default BestSellingProduct;